export default __webpack_public_path__ + "static/media/videoCourse.3a83d9f4.svg";